import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import {
  Button,
  Form,
  ModalContext,
  SidebarModal,
} from '@domain-group/suit-theme'

import useServiceProduct, { useServiceProductForm } from '@hooks/useServiceProduct'

const DuplicateServiceProductModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, duplicateServiceProduct } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const { serviceProduct } = digObject(modalData, modalKey, {})

  const serviceProductPayload = useServiceProduct(serviceProduct)
  const {
    callbacks: {
      duplicateServiceProduct: duplicateFn,
    },
    creating,
  } = serviceProductPayload

  const serviceProductForm = useServiceProductForm({
    ...serviceProduct,
    title: `${serviceProduct.title} Copy`,
  }, { validateOn: 'change' })

  const {
    entityState,
    entityState: { title },
    errors,
    handlers,
    saveEnabled,
  } = serviceProductForm

  const duplicateServiceProductPayload = {
    callbacks: {
      action: duplicateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'Product Duplicated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title="Duplicate"
        titleSecondLine="Product"
      />

      <SidebarModal.Content>
        <Form>
          <Form.Field errorMessage={errors.title} label="* New Title">
            <input name="title" type="text" value={title} {...handlers} />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => duplicateServiceProduct(duplicateServiceProductPayload)}
          size="large"
        >
          Duplicate Product
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

DuplicateServiceProductModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

DuplicateServiceProductModal.defaultProps = {
  modalKey: 'DuplicateServiceProductModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <DuplicateServiceProductModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
